import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

import { applyGeoFilterAndNavigate } from '@/pages/klienci/common/klienciFiltersStorage'
import useWojewodztwaData from './hooks/useWojewodztwaData'
import useWojewodztwaModal from './hooks/useWojewodztwaModal'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import WojewodztwaTable from './components/WojewodztwaTable'
import WojewodztwoModal from './components/WojewodztwoModal'

export default function Wojewodztwa() {
	const navigate = useNavigate()

	const {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		clearError,
	} = useWojewodztwaData()

	const {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		isSaving,
		closeModal,
		handleSubmit,
		buttons,
	} = useWojewodztwaModal(loadData)

	useEffect(() => {
		if (error) {
			Swal.fire({
				title: 'Error',
				text: error,
				icon: 'error',
			}).then(() => {
				clearError()
			})
		}
	}, [error, clearError])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSort = column => {
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
		setSorting(column, newDirection)
	}

	const handleSearchChange = e => {
		updateFilters({ searchText: e.target.value })
	}

	const handleNazwaClick = wojewodztwoId =>
		applyGeoFilterAndNavigate(navigate, {
			targetPageKey: 'powiat',
			path: '/klienci/powiat',
			filterKey: 'id_wojewodztwo',
			filterValue: wojewodztwoId,
		})

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder="Szukaj wojewodztw po nazwie..."
				buttons={buttons}
			/>

			<WojewodztwaTable
				data={data}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				onNazwaClick={handleNazwaClick}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={data.length}
				totalCount={totalCount}
			/>
			<WojewodztwoModal
				isOpen={isModalOpen}
				editingItem={editingItem}
				formName={formName}
				setFormName={setFormName}
				isSaving={isSaving}
				onClose={closeModal}
				onSubmit={handleSubmit}
			/>
		</>
	)
}
